/* globals process */

import React from "react";
import { Layout } from "antd";
import { css } from "glamor";
import { TunnelPlaceholder } from "react-tunnels";
import PageHeader from "@arachnys/styleguide/PageHeader";
import StickyMessage from "../component/StickyMessage";
import ErrorBoundary from "../container/ErrorBoundary";
import PrivateRoute from "../container/PrivateRoute";
import ContentWithHeader from "../container/ContentWithHeader";

const styles = {
    layout: css({ background: "#FFF" }),
    header: css({
        background: "#FFF",
        height: "auto",
        borderBottom: "solid 2px #00aeef",
    }),
};

const LayoutComponent = props => {
    const { children, TopBarComponent, layoutType, ...otherProps } = props;

    return (
        <Layout {...styles.layout}>
            <StickyMessage source={process.env.STICKY_MESSAGE_URL} />
            {layoutType === "blank" ? null : (
                <PrivateRoute
                    path="/"
                    redirectUnauthenticated={false}
                    styleless
                    render={() => (
                        <Layout.Header {...styles.header}>
                            {TopBarComponent(otherProps)}
                        </Layout.Header>
                    )}
                />
            )}

            <Layout.Content>
                <ErrorBoundary>
                    <ContentWithHeader
                        nomargin={layoutType === "login"}
                        header={
                            layoutType === "bar" ? (
                                <PageHeader
                                    title={
                                        <TunnelPlaceholder id="bluebar-title" />
                                    }
                                    rightContent={
                                        <TunnelPlaceholder id="bluebar-right-content" />
                                    }
                                    leftContent={
                                        <TunnelPlaceholder id="bluebar-left-content" />
                                    }
                                />
                            ) : null
                        }
                        content={children}
                    />
                </ErrorBoundary>
            </Layout.Content>
        </Layout>
    );
};

export default LayoutComponent;
